export default {
  PeriodName: "",
  Source: "User",
  Edited: true,
  PyWhtSeq: 0,
  PyhSeq: "",
  VnCode: "",
  PayeeName: "",
  Address: "",
  TaxId: "",
  PayDate: null,
  WhtTypeCode: "",
  WhtCode: "",
  WhtDesc: "",
  WhtRate: 0,
  Amount: 0,
  TaxAmt: 0,
  BranchNo: "",
  WhtNo: "",
  Remark1: "",
  Remark2: "",
  Dim: {
    Dim: [],
  },
  UserModified: localStorage.getItem("UserName"),
};
